import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Slider from 'react-slick'
import { Row, Col } from 'react-bootstrap'

import Content from '../../components/Content'
import { Container } from 'react-bootstrap'

import closeIcon from '../Projects/assets/closeIcon.svg'
import Form from '../../components/Form'
import List from './List'

import url from '../../config/url'
import {
  fetchDesigners,
  fetchDesignerPortfolio,
} from '../../model/designers/actions'

class Designers extends Component {
  state = {
    portfolio: [],
    data: [],
  }

  componentDidMount = () => {
    this.props.fetchDesigners()
    document.addEventListener('keydown', this.keyDown)
  }
  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.keyDown)
  }

  keyDown = e => {
    if (e.keyCode === 39) {
      this.next()
    }
    if (e.keyCode === 37) {
      this.previous()
    }
  }

  next = () => {
    this.slider.slickNext()
  }

  previous = () => {
    this.slider.slickPrev()
  }

  setPortfolio = activePortfolioId => {
    this.props.fetchDesignerPortfolio(activePortfolioId)
    this.setState({ activePortfolioId })
  }

  render() {
    const { activePortfolioId, portfolios = {} } = this.state
    const {
      designersList = [],
      designersPortfolios = {},
    } = this.props.designers
    const isSmallScreen = window.innerWidth <= 1024
    console.log('designers', this.props)
    console.log('portfolio', activePortfolioId)
    if (isSmallScreen) {
      return (
        <Container>
          <div style={{ marginTop: 50 }}></div>
          <Row>
            <Col>
              <Content className="animated fadeInLeft" />
            </Col>
          </Row>
          <Row>
            <Col>
              <List setPortfolio={this.setPortfolio} data={designersList} />
            </Col>
          </Row>

          <Form
            title="Вы дизайнер и хотите работать с нами?"
            btnText="Связаться с нами!"
            subject="Дизайнеры"
          />
          {activePortfolioId && (
            <Modal isOpen={designersPortfolios[activePortfolioId]}>
              <div className="modal-overlay"></div>
              <div className="body">
                <Maximize
                  src={closeIcon}
                  onClick={() => this.setPortfolio(null)}
                />
                <Slider ref={c => (this.slider = c)} {...settings}>
                  {(designersPortfolios[activePortfolioId] || []).map(
                    (el, key) => (
                      <div style={{ overflow: 'hidden' }} key={key}>
                        <SliderImage src={url + el.img} />
                      </div>
                    )
                  )}
                </Slider>
              </div>
            </Modal>
          )}
        </Container>
      )
    }
    return (
      <Container>
        <div style={{ marginTop: 50 }}></div>
        <Row>
          <Col sm={8}>
            <Content className="animated fadeInLeft" />
            <List
              portfolios={portfolios}
              setPortfolio={this.setPortfolio}
              data={designersList}
            />
          </Col>
          <Col sm={4}>
            <Form
              title="Вы дизайнер и хотите работать с нами?"
              btnText="Связаться с нами!"
              subject="Дизайнеры"
            />
          </Col>
        </Row>

        {activePortfolioId && (
          <Modal isOpen={designersPortfolios[activePortfolioId]}>
            <div className="modal-overlay"></div>
            <div className="body">
              <Maximize
                src={closeIcon}
                onClick={() => this.setPortfolio(null)}
              />
              <Slider ref={c => (this.slider = c)} {...settings}>
                {(designersPortfolios[activePortfolioId] || []).map((el, i) => (
                  <div style={{ overflow: 'hidden' }} key={i}>
                    <SliderImage src={url + el.img} />
                  </div>
                ))}
              </Slider>
            </div>
          </Modal>
        )}
      </Container>
    )
  }
}

export default connect(state => state, {
  fetchDesigners,
  fetchDesignerPortfolio,
})(Designers)

const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${props => (props.isOpen ? 9999 : -1)};
  display: flex;
  justify-content: center;
  align-items: center;
  & .modal-overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    backdrop-filter: blur(5px);
    background-color: rgba(0, 0, 0, 0.6);
    width: 100vw;
    height: 100vh;
  }
  & .body {
    width: 800px;
    max-width: 80%;
    min-width: 200px;
    -ms-transform: translate(-50%, -50%);
    border-radius: 8px;
    position: absolute;
  }
`

const Maximize = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  top: -25px;
  right: -25px;
`
const settings = {
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
}
const SliderImage = styled.div`
  border-radius: none;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: url(${props => props.src}) no-repeat center center;
  background-size: cover;
  border-radius: 0px;
  margin: auto;
`
